import React from 'react';

import BaseFilterChip from './BaseFilterChip';

type Props = {
  value?: string | null;
  onDelete: () => void;
};
export default function TimePeriodFilterChip({ value, onDelete }: Props) {
  switch (value) {
    case 'WEEK':
      return <BaseFilterChip label="This week" onDelete={onDelete} />;
    case 'MONTH':
      return <BaseFilterChip label="This month" onDelete={onDelete} />;
    case 'ALL':
    default:
      return null;
  }
}
